module.exports = __webpack_public_path__ + "images/164_2048.jpg";